<script setup lang="ts">
import { AuthWrapper as AuthContent, TextButton } from 'uicomponents';
import { computed } from 'vue';

import i18n from '@/i18n';
import AuthWrapper from '@/views/auth/AuthWrapper.vue';

const props = defineProps<{ blocked: boolean }>();
defineEmits<{ keepBothOpen: [] }>();

const t = i18n.global.t;

const title = computed(() =>
  props.blocked ? t('Access Denied') : t('Multiple Tabs Open')
);

const message = computed(() =>
  props.blocked
    ? t(
        'This event cannot be open in multiple tabs simultaneously. You can close other tabs, then refresh this page to continue here.'
      )
    : t(
        'This event is open in another tab. You can switch to that tab, or continue here. Watching in both tabs will play audio in both at the same time.'
      )
);
</script>

<template>
  <div class="fixed inset-0 z-[2147483647]" role="alertdialog" aria-modal="true" :aria-label="title">
    <AuthWrapper>
      <AuthContent :title="title" :contentHeader="message" :nextButton="false">
        <div v-if="!blocked" class="flex justify-center">
          <TextButton
            data-testid="continue-here"
            filled
            :uppercase="false"
            color="primary-text-color"
            variant="body14"
            @click="$emit('keepBothOpen')"
          >
            {{ $t('Continue Here') }}
          </TextButton>
        </div>
      </AuthContent>
    </AuthWrapper>
  </div>
</template>
